<template lang="pug">
  div(:class="{'pointer' : Boolean(selectable)}")
    .msg-row.d-flex.mb-2(
      v-for="(message, index) in parsed_conversation_messages",
      :class="(message.author === 'user' || message.author === 'platform' || message.event_type === 'case_message') ? 'align-items-flex-start' : 'align-items-flex-end'",
      :_id="message._id",
      v-viewer="viewer_options",
      :selected="selectedMessage && selectedMessage._id == message._id",
      @click="selectMessage(message)"
    )
      .text-center.w-100.text-sm.my-3(v-if="message.referral")
        b-link.text-center.mb-0(:href="message.referral.referral_url", target="_blank")
          zap-icon.icon-sm.mr-2
          span {{message.referral.type}}: {{ message.referral.title }}
        p.text-center.mb-0
          span 
        span.text-secondary ID: {{ message.referral.ref }}
      .text-center.w-100.text-sm.my-3(v-if="message.new_date")
        span.bg-light.text-dark.date-tag {{ message.new_date }}
      .w-100.px-5.text-center.text-sm.my-2(:event="message.event", v-if="message.event_type === 'case_message'")
        p.text-center.mb-0
          flag-icon.icon-sm.mr-2
          span {{ parseCaseEvent(message.event) }}
        span.text-secondary {{ putMessageHourWithTimezone(message.date) }}
      .w-100.px-5.text-center.text-sm.my-2(:event="message.event", v-else-if="message.event_type === 'note'")
        p.text-center.mb-0
          file-text-icon.icon-sm.mr-2
          span {{ message.event.title }}
        span.text-secondary {{ putMessageHourWithTimezone(message.date) }}
      .overflow-x.scrollable-area.w-100(v-else-if="message.gallery && message.gallery.length", style="white-space:nowrap;text-align:right;")
        .gallery-item.text-left(v-for="(item, index) in message.gallery", :key="index", v-if="item.title || item.subtitle || item.image_url || (item.buttons && item.buttons.length)")
          .img-container.position-relative(v-if="item.image_url")
            b-img(:src="item.image_url", :blank="!item.image_url", @error="item.image_url = ''", blank-color="#f2f2f2")
          .gallery-content
            .title(v-html="item.title")
            .subtitle(v-if="item.subtitle", v-html="item.subtitle")
            b-button.gallery-button(variant="light", v-for="(button, button_index) in item.buttons", :key="button_index", v-html="button.title")
      b-img.mw-60.mw-md-40(rounded, v-if="message.image", :src="message.image", fluid)
      b-img.mw-60.mw-md-40(rounded, v-if="message.attachment && message.attachment.type == 'image'", :src="message.attachment.url", fluid)
      chat-list-template(v-if="message.list && message.list.elements && message.list.elements.length", v-bind="message.list", small)
      .messenger-text(v-if="message.contacts && message.contacts.length")
        .text.text-dark Contactos:
        div(v-for="(contact, index) in message.contacts", :key="index", v-if="contact.name && contact.phones && contact.phones.length")
          .text {{ contact.name.formatted_name }}: {{ contact.phones[0].phone }}
      .messenger-text(v-if="message.attachment || message.text" :class="{user: (message.author === 'user' || message.author === 'platform'), 'text-buttons': (message.buttons && message.buttons.length) || (message.attachment && message.attachment.type !== 'audio')}")
        div(v-if="message.attachment && message.attachment.type !== 'audio'")
          b-link.d-none(:ref="'attachment_link_' + index", :href="message.attachment.url", target="blank")
          .text {{ getFileName(message.attachment) }}
          b-button.message-button(variant="outline-primary", @click="$refs['attachment_link_' + index][0].$el.click()") Descargar
            arrow-down-circle-icon.icon-md.ml-2
        div(v-if="showAudioFile(message)").d-flex.justify-content-end.align-items-center
          audio(controls, :src="message.attachment.url", :data-author="message.author")
        .textAnswered(v-if="message.wamIDAnswered", @click="goToMessage(message)") {{ findMessageText(message) }}
        .text(v-if="message.text", v-html="message.text")
        b-button.message-button(variant="light", v-for="(button, index) in message.buttons" :key="index", v-html="button.title")
      .location.mw-60.mw-md-40(v-if="message.location")
        LocationMessage(v-bind="message.location")
      .scrollable-area.mt-2(v-if="message.quick_replies && message.quick_replies.length")
        .quick-reply(v-for="quick_reply in message.quick_replies", v-html="quick_reply.title")
      .message-date.d-flex.align-items-center.text-secondary.text-sm.mt-1(v-if="message.event_type != 'case_message'") {{ putMessageHourWithTimezone(message.date, 'date') }}
        alert-circle-icon.ml-1.icon-md.text-secondary.hover-dark.pointer(@click="showData(message)")
            //div(@click="takeMessage(message)") ---> TO NEXT SPRINT | DO NOT DELETE PLEASE
              v-icon.icon-sm.mx-2.text-secondary.hover-dark.pointer(name="reply")
    b-modal(
      class="scrollable-area",
      scrollable,
      v-model="create_user_modal",
      title="Detalle del mensaje",
      ok-only,
      ok-title='Cerrar detalle',
      ok-variant="secondary"
    )
      message-details(:message_id="selected_message._id", :timezone="timezone")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import ChatListTemplate from './ChatListTemplate'
import LocationMessage from './LocationMessage'
import MessageDetails from '../components/MessageDetails'

const conversationController = createNamespacedHelpers('conversation')

export default {
  data () {
    return {
      create_user_modal: false,
      selected_message: {},
      timezone: '',
      messageTook: {}
    }
  },
  props: {
    parsed_conversation_messages: {
      type: Array,
      default: function () {
        return []
      }
    },
    viewer_options: {
      type: Object,
      default: function () {
        return {}
      }
    },
    tags: {
      type: Array,
      default: function () {
        return []
      }
    },
    admins: {
      type: Array,
      default: function () {
        return []
      }
    },
    groups: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectable: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...conversationController.mapGetters(['selectedMessage']),
  },
  methods: {
    ...mapActions(['account/get']),
    getAccount() {
      this['account/get']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          const { resource = {} } = res
          const { timezone = 'America/Mexico_City' } = resource

          if (res.error) return this.$message.error(res.error)

          this.timezone = timezone || this.$moment.tz.guess()
        }
      })
    },
    showAudioFile(message) {
      const { attachment = {} } = message || {}
      const { type } = attachment || {}

      return type === 'audio'
    },
    showData(message) {
      this.create_user_modal = true
      this.selected_message = message
    },
    takeMessage({
      text = '',
      wamID = '',
      wamIDAnswered = '',
      external_id: externalId = ''
    }) {
      this.messageTook = { text, wamID, wamIDAnswered, externalId }

      return this.messageTook
    },
    findMessageText(message) {
      const index = this.parsed_conversation_messages.findIndex(({ wamID, external_id }) => {
        return wamID === message.wamIDAnswered || external_id === message.wamIDAnswered
      })

      if (index >= 0) return this.parsed_conversation_messages[index].text
    },
    findMessage(message) {
      const index = this.parsed_conversation_messages.findIndex(({ wamID, external_id }) => {
        return wamID === message.wamIDAnswered || external_id === message.wamIDAnswered
      })

      if (index >= 0) return this.parsed_conversation_messages[index]
    },
    goToMessage(message) {
      const messageFound = this.findMessage(message)

      this.$emit('goToExactMessage', messageFound)
    },
    parseCaseEvent (event) {
      let from,
        to,
        admin_from,
        admin_to,
        group_from,
        group_to,
        added_tags,
        deleted_tags,
        added_tags_objects,
        deleted_tags_objects

      switch (event.name) {
        case 'assigment':
          from = event.payload.from,
          to = event.payload.to,
          admin_from, admin_to

          if (from) admin_from = this.admins.find(a => a.admin_id == from)
          if (to) admin_to = this.admins.find(a => a.admin_id == to)
          if (admin_from && admin_to) {
            return `Se reasignó el caso de ${admin_from.email} a ${admin_to.email}.`
          } else if (admin_to) {
            return `Se asignó el caso a ${admin_to.email}.`
          }
          break
        case 'derivation':
          from = event.payload.from,
          to = event.payload.to,
          group_from, group_to

          if (from) group_from = this.groups.find(a => a.group_id == from)
          if (to) group_to = this.groups.find(a => a.group_id == to)
          if (group_from && group_to) {
            return `Se derivó el caso de ${group_from.name} a ${group_to.name}.`
          } else if (group_to) {
            return `Se derivó el caso a ${group_to.name}.`
          }
          break
        case 'status_change':
          from = event.payload.from,
          to = event.payload.to

          if (from && to) {
            return `Cambió de estatus de ${from.capitalize()} a ${to.capitalize()}.`
          }

          if (to) {
            return `Cambio de estatus a ${to.capitalize()}.`
          }
          break
        case 'tags_change':
          try {
            added_tags = event.payload.added ? event.payload.added.slice() : []
            deleted_tags = event.payload.removed ? event.payload.removed.slice() : []
            added_tags_objects = this.tags.filter(t => added_tags.includes(t.tag_id)).map(t => t.name).join(', ')
            deleted_tags_objects = this.tags.filter(t => deleted_tags.includes(t.tag_id)).map(t => t.name).join(', ')

            let text = ''

            if (added_tags.length) {
              text += 'Se agregaron las etiquetas: ' + added_tags_objects + '. '
            }

            if (deleted_tags.length) {
              text += 'Se eliminaron las etiquetas: ' + deleted_tags_objects + '.'
            }

            return text
          } catch (e) {
            console.log(e.message)
            return 'Se agregaron o eliminaron etiquetas.'
          }
          break
        default:
          return ''
      }
    },
    getFileName(file) {
      const field = file.url || file.src

      if (!field) return 'Nombre de archivo no disponible'

      try {
        return decodeURIComponent(
          field.match(/\.com\/.+\.\w{3,4}/gmi)[0].split('/').slice(-1)[0]
        )
      } catch (e) {
        console.log(e.message)

        return 'Nombre de archivo no disponible'
      }
    },
    selectMessage(message) {
      if (this.selectable) this.$store.commit('conversation/selectMessage', message)
    },
    putMessageHourWithTimezone(messageDate, format = 'hours') {
      if (messageDate && this.timezone && format === 'hours') {
        return this.$moment(messageDate).tz(this.timezone).format('hh:mm A')
      }

      if (messageDate && this.timezone && format === 'date') {
        return this.$moment(messageDate).tz(this.timezone).format('DD MMM YYYY hh:mm A')
      }
    }
  },
  mounted() {
    this.getAccount()
  },
  watch: {
    messageTook: function () {
      this.$emit('messageTook', this.messageTook)
    }
  },
  components: { ChatListTemplate, MessageDetails, LocationMessage }
}
</script>

<style lang="scss" scoped>
audio::-webkit-media-controls-panel {
  background-color: #f1f0f0;
}

audio[data-author="user"]::-webkit-media-controls-panel {
  background-color: #0099ff;
  border-color: #0099ff;
}
audio::-webkit-media-controls-timeline-container {
  width: 40px;
  max-width: 40px;
}

audio::-webkit-media-controls-current-time-display {
  visibility: visible;
  font-size: 15px;
}

audio::-webkit-media-controls-time-remaining-display {
  visibility: visible;
  font-size: 15px;
}

audio::-webkit-media-controls-play-button {
  background-color: rgba(183, 206, 255, 1);
  border-radius: 50px;
  padding: 15px;
}

audio::-webkit-media-controls-play-button:hover {
  background-color: #ccdcff;
}
.text {
  white-space: break-spaces;
}

.textAnswered {
  background-color: rgba(0,0,0,0.2);
  color: white !important;
  white-space: break-spaces;
  border-radius: 8px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  padding: 5px 10px;
  margin-bottom: 5px;
  border-left: 4px solid #243AE5;
  text-decoration: none !important;
  cursor: pointer;
  margin-top: 6px;
}
.date-tag {
  padding: 5px 15px;
  border-radius: 15px;
}
.msg-row {
  &[selected] {
    border-left: 2px solid #0e5ccf;
    border-right: 2px solid #0e5ccf;
    background-color: rgba(14, 92, 207, 0.1);
  }
}
</style>
